/*
 * @Author: your name
 * @Date: 2022-02-26 10:34:43
 * @LastEditTime: 2022-03-08 15:48:27
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \kares_pad\src\i18n\index.js
 */
import Vue from 'vue'
import language from './language'
import VueI18n from 'vue-i18n'
import ElementLocale from 'element-ui/lib/locale'
Vue.use(VueI18n);
const i18n = new VueI18n({
    locale: 'zh', // set locale
    messages: language, // set locale language
    silentTranslationWarn: true
});

// this.$i18n.locale = 'zh'    //设置中文
// this.$i18n.locale = 'en'    //设置英文

ElementLocale.i18n((key, value) => i18n.t(key, value));

export default i18n;
// export function $t(args) {
//     return i18n.tc.call(i18n, args);
// }